import React from 'react';
import BaseOutlierCountAlert from "./BaseOutlierCountAlert";

const UnitsCountOutlier = () => {
    return <BaseOutlierCountAlert accessor={'unit'} alertType={'Unit'} threshold={25}/>;
};

export default UnitsCountOutlier;